import type { NeuronId, SerialNumber } from "~domain/devices/models/common-device-model.ts";
import type { ModulatorCsId, ModulatorHwId } from "~domain/devices/models/modulators/modulator-model.ts";
import type { ModulatorTypeId } from "~domain/devices/models/modulators/modulator-type-model.ts";
import type { PilotCsId, PilotHwId } from "~domain/devices/models/pilot/pilot-model.ts";
import type { SiteId } from "~domain/sites/models/site-model.ts";

import { z } from "zod";

/**
 * Yes..... Instead of a 404 or 500 or whatever, backoffice returns a blank 200.........
 */
export const backofficeFindModulatorResponseRawSchema = z.object({
  applianceTypeTranslationKey: z.string().nullable(),
  creationDatetime: z.coerce.date(),
  csId: z
    .number()
    .transform((s) => s as ModulatorCsId)
    .nullable(),
  hwId: z.number().transform((s) => s as ModulatorHwId),
  links: z.array(z.any()).nullable(),
  location: z.string().nullable(),
  measuredPower: z.number().nullable(),
  modbus: z.boolean(),
  modnum: z.number().nullable(),
  momboxCsId: z
    .number()
    .transform((s) => s as PilotCsId)
    .nullable(),
  momboxId: z
    .number()
    .transform((s) => s as PilotHwId)
    .nullable(),
  neuronId: z.string().transform((s) => s as NeuronId),
  pairingStatus: z.any(), // TODO: check what it is
  refOperatingStatus: z.number(), // TODO: check what it is
  roomTypeTranslationKey: z.string().nullable(),
  serialNumber: z
    .string()
    .nullable()
    .transform((s) => s as SerialNumber),
  siteId: z
    .number()
    .transform((s) => s as SiteId)
    .nullable(),
  vx: z.boolean(),
  v2V5: z.boolean(),
  type: z.object({
    id: z.number().transform((s) => s as ModulatorTypeId),
    label: z.string(),
    measurementType: z.any().nullable(), // TODO: check what it is
    measurementUnit: z.any().nullable(), // TODO: check what it is
    meter: z.boolean(),
    modbus: z.boolean(),
    nbMeasure: z.number(),
    nbTinf: z.number(),
    note: z.string(),
    v2V5: z.boolean(),
    value: z.number(),
    vx: z.boolean(),
    vxRelay: z.boolean(),
    vxWire: z.boolean(),
    zigbeeStandard: z.boolean(),
  }),
});

export const backofficeFindModulatorResponseSchema = backofficeFindModulatorResponseRawSchema.or(z.void());

export type BackofficeFindModulatorResponse = z.infer<typeof backofficeFindModulatorResponseSchema>;
